export const ACTIVISM = 'Activism';
export const SHORTS = 'Activist Shorts';
export const VOTING = 'Voting';
export const GOVERNANCE = 'Governance';
export const COMPENSATION = 'Compensation';
export const VULNERABILITY = 'Vulnerability';
export const NEWS = 'News';

export const MAIN_EVENTS = 'Main Events';
export const CAMPAIGNS = 'Campaigns';

export const SHAREHOLDER_REQUITION_OF_MEETINGS = 'Shareholder Requition of Meetings';

export const DROPPABLEID_ITEMS = 'ITEMS';

export default {
  ACTIVISM,
  SHORTS,
  VOTING,
  GOVERNANCE,
  COMPENSATION,
  VULNERABILITY,
  MAIN_EVENTS,
  CAMPAIGNS,
  SHAREHOLDER_REQUITION_OF_MEETINGS,
  DROPPABLEID_ITEMS
};
